// Actionsheet
export const Actionsheet = {
  defaultProps: {
    size: 'xl',
  },
};

// ActionsheetContent
export const ActionsheetContent = {
  baseStyle: {
    m: 3,
    p: 2,
    mb: 6,
    borderRadius: 'lg',
  },
};

// ActionsheetHeader
export const ActionsheetHeader = {};

// ActionsheetFooter
export const ActionsheetFooter = {
  baseStyle: {
    m: 3,
    p: 2,
    mb: 6,
    borderRadius: 'lg',
  },
};

// ActionsheetItem
export const ActionsheetItem = {};
